<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <div v-else>
            <b-row>
                <b-col lg="6" sm="12" class="dashboard-wrapper">
                    <b-card>
                        <template v-slot:header>
                            <h5>Elektronik, Kendaraan & Emas</h5>
                        </template>
                        <div class="d-flex align-items-center">
                            <b-form-select class="mr-2" v-model="input.smsElekKend" name="smsElekKend" :options="elekKendOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-button variant="pgiBtn" class="sms-wrapper-btn" :disabled="isLoading" @click="confirmElekKendDownload()">
                                <i class="fa fa-download mr-2"></i>
                                Download
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
                <b-col lg="6" sm="12" class="dashboard-wrapper">
                    <b-card>
                        <template v-slot:header>
                            <h5>BPKB</h5>
                        </template>
                        <div class="d-flex align-items-center">
                            <b-form-select class="mr-2" v-model="input.smsBpkb" name="smsBpkb" :options="bpkbOption" value-field="id" text-field="name">
                                <template v-slot:first>
                                    <b-form-select-option :value="null" disabled>-- Please select an option --</b-form-select-option>
                                </template>
                            </b-form-select>
                            <b-button variant="pgiBtn" class="sms-wrapper-btn" :disabled="isLoading" @click="confirmBpkbDownload()">
                                <i class="fa fa-download mr-2"></i>
                                Download
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
                <b-col lg="6" sm="12" class="dashboard-wrapper">
                    <b-card>
                        <template v-slot:header>
                            <h5>Gadai Baru</h5>
                        </template>
                        <div class="d-flex align-items-center">
                            <b-form-input class="mr-2"
                                v-model="input.smsGadaiBaru" name="smsGadaiBaru"
                                id="smsGadaiBaru"
                                type="date"
                            ></b-form-input>
                            <b-button variant="pgiBtn" class="sms-wrapper-btn" :disabled="isLoading" @click="confirmGadaiBaruDownload()">
                                <i class="fa fa-download mr-2"></i>
                                Download
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
                <b-col lg="6" sm="12" class="dashboard-wrapper">
                    <b-card>
                        <template v-slot:header>
                            <h5>Pelunasan</h5>
                        </template>
                        <div class="d-flex align-items-center">
                            <b-form-input class="mr-2"
                                v-model="input.smsPelunasan" name="smsPelunasan"
                                id="smsPelunasan"
                                type="date"
                            ></b-form-input>
                            <b-button variant="pgiBtn" class="sms-wrapper-btn" :disabled="isLoading" @click="confirmPelunasanDownload()">
                                <i class="fa fa-download mr-2"></i>
                                Download
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
                <b-col lg="6" sm="12" class="dashboard-wrapper">
                    <b-card>
                        <template v-slot:header>
                            <h5>Ulang Tahun</h5>
                        </template>
                        <div class="d-flex align-items-center">
                            <b-form-input class="mr-2"
                                v-model="input.smsUlangTahun" name="smsUlangTahun"
                                id="smsUlangTahun"
                                type="date"
                            ></b-form-input>
                            <b-button variant="pgiBtn" class="sms-wrapper-btn" :disabled="isLoading" @click="confirmUlangTahunDownload()">
                                <i class="fa fa-download mr-2"></i>
                                Download
                            </b-button>
                        </div>
                    </b-card>
                </b-col>
            </b-row>
            <b-row>
                <b-col lg="6" sm="12" class="dashboard-wrapper">
                    <b-card>
                        <template v-slot:header>
                            <h5>Blast SMS</h5>
                        </template>
                        <b-form @submit.prevent="confirmBlastGenerate">
                            <div class="form-content-wrapper mb-4">
                                <b-form-group label="Tipe">
                                    <b-form-select v-model="input.type">
                                        <b-form-select-option :value="null">-- Pilih Tipe --</b-form-select-option>
                                        <b-form-select-option :value="1">Nasabah dengan gadai aktif di cabang...</b-form-select-option>
                                        <b-form-select-option :value="2">Nasabah aktif yang didaftarkan di cabang...</b-form-select-option>
                                    </b-form-select>
                                </b-form-group>
                                <b-form-group label="Cabang">
                                    <multiselect
                                        class="ml-0"
                                        name="cabangBlast"
                                        v-model="input.cabangBlast" 
                                        :options="cabangBlastOption" 
                                        :internal-search="true"
                                        :allow-empty="false"
                                        deselect-label=""
                                        select-label=""
                                        label="name"
                                        track-by="name"
                                    />
                                </b-form-group>
                                <b-form-group label="Teks" class="mb-1">
                                    <b-form-textarea v-model="input.keteranganBlast" @keyup="counterKeterangan" name="Keterangan" required></b-form-textarea>
                                    <span class="text-area-counter text-right text-muted smallText">{{keteranganBlastCounter}} Karakter</span>
                                </b-form-group>
                                <p class="smallText text-muted">
                                    Pilihan cabang akan mengambil semua nasabah yang terdaftar pada cabang tersebut.
                                </p>
                                <p class="smallText text-muted">
                                    Gunakan <strong>#nama</strong> untuk menggunakan nama nasabah, dan <strong>#telp</strong> untuk menggunakan no telepon cabang.
                                </p>
                                <p class="smallText text-muted">
                                    Sebagai contoh, "Selamat pagi Bpk / Ibu <strong>#nama</strong>, silahkan hubungi <strong>#telp</strong>" akan diubah menjadi "Selamat pagi Bpk / Ibu <strong>Rahmat</strong>, silahkan hubungi <strong>081921928232</strong>"
                                </p>
                            </div>
                            <div class="form-wrapper-btn d-flex justify-content-end">
                                <b-button variant="pgiBtn" type="submit" class="sms-wrapper-btn" :disabled="isLoading">
                                    <i class="fa fa-download mr-2"></i>
                                    Download
                                </b-button>
                            </div>
                        </b-form>
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <b-modal id="modal-download-excel" @hidden="resetInput" centered title="Download Excel" hide-footer no-close-on-backdrop>
            <div class="text-center" v-if="isLoading == true">
                <b-spinner class="align-middle mb-4"></b-spinner>
                <p class="mb-0">Sedang memproses, mohon menunggu...</p>
            </div>
            <div class="show-btn-download" v-else>
                <p class="">
                    Silakan download dengan klik tombol dibawah ini :
                </p>
                <b-button variant="pgiBtn" class="mb-0 download-btn">
                    <a v-bind:href="$baseFilePath + filePathDownload" download>
                        <i class="fa fa-download mr-2"></i>
                        Download Excel
                    </a>
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'sms',
    data() {
        return {
            initStatus: 0,
            keteranganBlastCounter: 0,
            input:{
                smsElekKend: null,
                smsBpkb: null,
                smsGadaiBaru: null,
                smsPelunasan: null,
                smsUlangTahun: null,
                type:null,
                cabangBlast: null,
                keteranganBlast: ""
            },
            elekKendOption:[
                { id: 101, name: 'H-2'},
                { id: 102, name: 'H-1'},
                { id: 103, name: 'H+1, H+4, H+8'},
                { id: 104, name: 'H+3, H+7'},
                { id: 105, name: 'H+14'},
                { id: 106, name: 'H+15'}
            ],
            bpkbOption: [
                { id: 201, name: 'H-2'},
                { id: 202, name: 'H-1'},
                { id: 203, name: 'H+1, H+4, H+8'},
                { id: 204, name: 'H+3, H+7'},
                { id: 205, name: 'H+14'},
                { id: 206, name: 'H+15'},
                { id: 207, name: 'H+21'},
                { id: 208, name: 'H+22'},
                { id: 209, name: 'H+29'},
                { id: 210, name: 'H+30'},
                { id: 211, name: 'H+59'},
                { id: 212, name: 'H+60'}
            ],
            cabangBlastOption: [],
            isLoading: false,
            filePathDownload: "",
            todayDate: null
        }
    }, 
    methods: {
        
        init(){
            this.initStatus = 0

            var today = new Date();
            var dd = today.getDate();
            var mm = today.getMonth()+1; //January is 0!
            var yyyy = today.getFullYear();
            if(dd<10){
                    dd='0'+dd
                } 
                if(mm<10){
                    mm='0'+mm
                } 

            today = yyyy+'-'+mm+'-'+dd;
            this.todayDate = today
            this.input.smsGadaiBaru = today
            this.input.smsPelunasan = today
            this.input.smsUlangTahun = today

            let getCabangBlastOption = this.$axios.get("cabang/all-selection").then(response => {
                response.data.forEach((element) => {
                    this.cabangBlastOption.push(element)
                })
            })

            Promise.all([getCabangBlastOption]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })
        },

        resetInput(){
            this.input.smsElekKend = null
            this.input.smsBpkb = null
            this.input.smsGadaiBaru = this.todayDate
            this.input.smsPelunasan = this.todayDate
            this.input.smsUlangTahun = this.todayDate
            this.input.cabangBlast = null
            this.input.keteranganBlast = ""
            this.input.type = null
        },

        //elek kend

        confirmElekKendDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.smsElekKend)){
                this.$helper.toastErr(this, "Mohon isi inputan terlebih dahulu!")
            }else{
                this.openElekKendDownload()
            }
        },

        openElekKendDownload(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            setTimeout(() => { this.axiosElekKendDownload() }, 500)
        },

        axiosElekKendDownload(){
            this.$axios.get(`sms/elektronik-kendaraan/?id=${this.input.smsElekKend}`).then(response => {
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //bpkb

        confirmBpkbDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.smsBpkb)){
                this.$helper.toastErr(this, "Mohon isi inputan BPKB terlebih dahulu!")
            }else{
                this.openBpkbDownload()
            }
        },

        openBpkbDownload(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            setTimeout(() => { this.axiosBpkbDownload() }, 500)
        },

        axiosBpkbDownload(){
            this.$axios.get(`sms/bpkb/?id=${this.input.smsBpkb}`).then(response => {
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //gadai baru

        confirmGadaiBaruDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.smsGadaiBaru)){
                this.$helper.toastErr(this, "Mohon isi tanggal gadai baru terlebih dahulu!")
            }else{
                this.openGadaiBaruDownload()
            }
        },

        openGadaiBaruDownload(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            setTimeout(() => { this.axiosGadaiBaruDownload() }, 500)
        },

        axiosGadaiBaruDownload(){
            this.$axios.get(`sms/gadai-baru/?tanggal=${this.input.smsGadaiBaru}`).then(response => {
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //pelunasan

        confirmPelunasanDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.smsPelunasan)){
                this.$helper.toastErr(this, "Mohon isi tanggal pelunasan terlebih dahulu!")
            }else{
                this.openPelunasanDownload()
            }
        },

        openPelunasanDownload(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            setTimeout(() => { this.axiosPelunasanDownload() }, 500)
        },

        axiosPelunasanDownload(){
            this.$axios.get(`sms/pelunasan/?tanggal=${this.input.smsPelunasan}`).then(response => {
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //ulang tahun

        confirmUlangTahunDownload(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.smsUlangTahun)){
                this.$helper.toastErr(this, "Mohon isi tanggal ulang tahun terlebih dahulu!")
            }else{
                this.openUlangTahunDownload()
            }
        },

        openUlangTahunDownload(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            setTimeout(() => { this.axiosUlangTahunDownload() }, 500)
        },

        axiosUlangTahunDownload(){
            this.$axios.get(`sms/ulang-tahun/?tanggal=${this.input.smsUlangTahun}`).then(response => {
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
        },

        //blast

        counterKeterangan(){
            this.keteranganBlastCounter = this.input.keteranganBlast.length
        },

        confirmBlastGenerate(){
            if(!this.$helper.isNotNullAndNotEmpty(this.input.cabangBlast)){
                this.$helper.toastErr(this, "Mohon isi cabang terlebih dahulu!")
            }else{
                this.openBlastGenerate()
            }
        },

        openBlastGenerate(){
            this.isLoading = true
            this.$bvModal.show('modal-download-excel')
            setTimeout(() => { this.axiosBlastGenerate() }, 500)
        },

        axiosBlastGenerate(){

            let payload = new FormData()
            payload.append("cabangId", this.input.cabangBlast.id)
            payload.append("text", this.input.keteranganBlast)
            payload.append("type", this.input.type)

            this.$axios.post(`sms/blast/`, payload).then(response => {
                this.filePathDownload = response.data
            })
            .catch(error => {
                console.log(error)
                console.log(error.response.data.reason)
                this.$bvModal.hide('modal-download-excel')
                this.$helper.toastErr(this, error.response.data.reason)
            })
            .finally(() => {
                this.isLoading = false
            })
            
        }

    },
    created() {
        this.init()
    }
}
</script>
